﻿$.fn.dxCtrlContentPlanitiRdv = function custom_dxCtrlContentPlanitiRdv(option) {
    if (option == "instance") {
        return this.instance;
    }
    else {
        this.addClass("dx-ctrlcontentplanitirdv dx-ctrl");
        this.createInstance(new cdxCtrlContentPlanitiRdv(this, option));
    }
    return this;
}

window.cdxCtrlContentPlanitiRdv = function (container, option) {
    var Me = this;


    this.option = function (name, value) {
        if (typeof value == 'undefined') {
            return option[name];
        }
        else {
            option[name] = value;
            dx.option(name, value);
        }
    }

    function mConstruit() {
        container.empty();

        $("<div style='padding:10px;'/>").appendTo(container).dxCtrlTextBox({
            labelMode: 'floating',
            label: "Objet",
            value: option.data.body_txt,
            onValueChanged: function (e) {
                option.data.body_txt = e.value
            },
            onContentReady: function (e) {
                window.setTimeout(function () { e.component.focus(); }, 700)
            }
        })

        $("<div/>").appendTo(container).dxCtrlDateRdv({
            bddCtrl: option.bddCtrl,
            date_debut: option.data.date_debut,
            date_fin: option.data.date_fin,
            readOnly: (option.data.externe == "1"),
            onValueChanged: function (dateDebut, dateFin) {
                option.data.date_debut = dateDebut
                option.data.date_fin = dateFin
            }
        })

        $("<div style='margin:10px;font-style:italic;white-space:normal;font-size:90%;'>La période défini bloquera les plages horaires pour tous les évènements proposés à vos correspondants.</div>").appendTo(container)

        mAddButtonOkAnnuler(container, function () {
            option.bddCtrl.getObjet(option.data).mSave()
            option.onClose()
        }, function () {
            option.onClose()
        }, null, null, function () {
            option.bddCtrl.getObjet(option.data).mDelDataDefinitif()
            option.onClose()
        },"Supprimer")
    }

    this.element = function () { return container; }

    mConstruit();
}